import { ApiClient } from '../helpers/api-client/ApiClient'
import { ResponseStatuses } from '../enums/ResponseStatuses'

export default function auth ({ next, nextMiddleware, store, to }) {
  if (to.query.logout) {
    return ApiClient.logout()
      .then(response => {
        if (response.data.status === ResponseStatuses.Success) {
          store.dispatch('flushAuthorize')
        }

        return next('/login')
      })
  }

  const handleResponse = response => {
    if (response.status !== 401 && response.data.status === ResponseStatuses.Success) {
      ApiClient.backendLogin()

      return nextMiddleware()
    }

    store.dispatch('flushAuthorize')

    return next('/login')
  }

  return ApiClient.userMe()
    .then(response => {
      store.commit('setUser', response.data.data)
      ApiClient.userPermissions()
        .then(response => {
          store.commit('setPermissions', response.data.data)
        })

      return handleResponse(response)
    })
    .catch(error => handleResponse(error.response))
}
